import axios from "axios";
import router from "@/router";
import store from "@/store";
import '@/plugins/dayjs'
import rollbar from '@/plugins/rollbar'


export default {
    state: {
        accessToken: null,
        refreshToken: null,
        userName: null,
        userRole: null,
        groupSetting: {
            groupName: null,
            mainColor: 'primary',
            groupUrl: null,
            logoUrl: null,
            faviconUrl: null
        }
    },
    mutations: {
        setTokens(state, payload) {
            state.accessToken = payload.token
            state.refreshToken = payload.token
            state.userName = payload.userName
            state.userRole = payload.userRole
            state.groupSetting = payload.groupSetting
        },
        setGroupSetting(state, payload) {
            state.groupSetting.groupName = payload.name,
            state.groupSetting.mainColor = payload.mainColor,
            state.groupSetting.groupUrl = payload.groupUrl,
            state.groupSetting.logoUrl = payload.logoUrl,
            state.groupSetting.faviconUrl = payload.faviconUrl
        }
    },
    getters: {
        getUserName: function(state) {
            return state.userName
        },
        getUserRole: function(state) {
            return state.userRole
        },
        getAccessToken: function(state) {
            return state.accessToken
        },
        getRefreshToken: function(state) {
            return state.refreshToken
        },
        getGroupSetting: function() {

            const host = location.host.split(':')

            let setting
            if(host[0] == "process.bspojang.com" || host[0] == "process.bspojang.co.kr"){
                setting = {
                    groupId: 1,
                    groupName: "방산포장",
                    mainColor: 'primary',
                    groupUrl: "https://process.bspojang.com",
                    logoUrl: "https://image.bspojang.com/production/group%2F1%2Flogo/logo_cA3r_s.svg",
                    logoSize: "25",
                    faviconUrl: "https://image.bspojang.com/production/group%2F1%2Flogo/favicon_f_x3Fz.ico",
                    groupAddress: "서울 중구 을지로 27길 6 1층",
                    groupPhone: "02-2264-1339"
                }
            }else if(host[0] == "demo.hoxy.io"){
                setting = {
                    groupId: 3756,
                    groupName: "풀림소프트",
                    mainColor: 'green',
                    groupUrl: "https://demo.hoxy.io",
                    logoUrl: "https://image.bspojang.com/production/group%2F1%2Flogo/logo_cA3r_s.svg",
                    logoSize: "25",
                    faviconUrl: "https://image.bspojang.com/production/group%2F1%2Flogo/favicon_f_x3Fz.ico",
                    groupAddress: "",
                    groupPhone: ""
                }
            }else if(host[0] == "pg.packagehouse.co.kr"){
                setting = {
                    groupId: 2,
                    groupName: "패키지하우스",
                    mainColor: '#5DB7E8',
                    groupUrl: "https://pg.packagehouse.co.kr",
                    logoSize: "55",
                    logoUrl: "https://image.bspojang.com/production/group%2F2%2Flogo/logo_3d_szF.png",
                    faviconUrl: "https://image.bspojang.com/production/group%2F2%2Flogo/favicon_3Kv-8a.png",
                    groupAddress: "서울 중구 마른내로 137, 상명빌딩 1층",
                    groupPhone: "02-2293-1600"
                }
            }else{
                setting = {
                    groupId: 3756,
                    groupName: "풀림",
                    mainColor: '#FF168D',
                    groupUrl: "localhost",
                    logoSize: "100",
                    logoUrl: "http://pullim.co.kr/theme/eb4_basic/image/site_logo.png",
                    faviconUrl: "http://pullim.co.kr/theme/eb4_basic/image/site_logo.png",
                    groupAddress: "",
                    groupPhone: "",
                }
                setting = {
                    groupId: 1,
                    groupName: "방산포장",
                    mainColor: 'primary',
                    groupUrl: "https://process.bspojang.com",
                    logoUrl: "https://image.bspojang.com/production/group%2F1%2Flogo/logo_cA3r_s.svg",
                    logoSize: "25",
                    faviconUrl: "https://image.bspojang.com/production/group%2F1%2Flogo/favicon_f_x3Fz.ico",
                    groupAddress: "서울 중구 을지로 27길 6 1층",
                    groupPhone: "02-2264-1339"
                }
            }

            return setting
            // return state.groupSetting
        }
    },
    actions: {
        getSignedIn({ commit }, payload) {

            if(!payload.userId){
                alert('아이디를 입력하세요.')
                return false
            }

            if(!payload.password){
                alert('패스워드를 입력하세요.')
                return false
            }

            let groupSetting = store.getters.getGroupSetting

            return axios({
                method: 'POST',
                headers: {
                    'groupId': groupSetting.groupId,
                    'userId': payload.userId,
                    'password': payload.password
                },
                url: store.getters.getApiUrl + '/api/v1/user/login',
                timeout: store.getters.getApiRequestTimeLimit
            })
            .then((response) => {

                if(response.data.status == "9999"){
                    alert(response.data.message)
                    return
                }

                if(response.data != null && response.data.type && response.data.type == 'bearer'){

                    //로그인 성공 시
                    commit("setTokens", response.data)

                    //대시보드로 이동
                    router.push('/dashboard')

                }

            })
            .catch((response) => {

                console.log(response)

                //로그인 실패 시
                alert('로그인 정보를 확인해주세요.')
                commit("setTokens", {token: null, refreshToken: null, userName: null})
                rollbar.error('로그인 실패', payload)

            })

        },
        userLogout({ commit }) {

            commit("setTokens", {token: null, refreshToken: null, userName: null})
            router.push('/user/login')

        },
        customerLogout({ commit }, payload) {

            commit("setClientInfo", {clientCode: null, clientPhone: null, clientName: null})
            router.push('/client/login/' + payload)

        },
        checkDuplicateName({ type }, payload) {

            if(payload.bypass){
                console.log(type)
                return false
            }

            return axios({
                method: 'POST',
                headers: {
                    'Authorization': 'bearer ' + this.getters.getAccessToken
                },
                url: store.getters.getApiUrl + '/api/v1/client/checkDuplicateName',
                data: {
                    type: payload.type,
                    name: payload.name
                },
                timeout: this.$store.getters.getApiRequestTimeLimit
            })
            .then(response => {

                if(response.data != null && response.data.status && response.data.status == '9966'){

                    if(!confirm(response.data.message)){

                        return '0000'

                    }

                }

            })

        },
        saveClient({ type }, payload) {

            console.log(type)
            console.clear()

            if(!payload.clientName) {
                alert('거래처명을 입력해주세요.')
                return false
            }

            if(!payload.clientPhone) {
                alert('연락처를 입력해주세요.')
                return false
            }

            return axios({
                method: 'POST',
                headers: {
                    'Authorization': 'bearer ' + this.getters.getAccessToken
                },
                url: store.getters.getApiUrl + '/api/v1/client/add',
                data: {
                    type: 'general',
                    name: payload.clientName,
                    brand: payload.clientBrand,
                    phone: payload.clientPhone,
                    email: payload.clientEmail,
                    comment: payload.clientComment
                },
                timeout: this.getters.getApiRequestTimeLimit
            })
            .then(response => {

                if(response.data != null && response.data.status && response.data.status == '0000'){

                    //거래처 추가 성공 시
                    alert('정상적으로 추가되었습니다.')
                    return '0000'

                }

            })
            .catch((error) => {

                if(error && error.name == "InvalidJwtToken"){

                    //JWT 토큰이 정확하지 않을 시
                    alert('인증 토큰이 유효하지 않습니다.')
                    return false

                }else{

                    //저장 실패 시
                    alert('거래처 등록에 실패했습니다.\n다시 시도해주세요.')

                }


            })

        },
        saveFactory({ type }, payload) {

            console.log(type)
            console.clear()

            if(!payload.factoryName) {
                alert('거래처명을 입력해주세요.')
                return false
            }

            if(!payload.factoryPhone) {
                alert('연락처를 입력해주세요.')
                return false
            }

            if(!payload.factoryGroup) {
                alert('분류를 입력해주세요.')
                return false
            }

            return axios({
                method: 'POST',
                headers: {
                    'Authorization': 'bearer ' + this.getters.getAccessToken
                },
                url: store.getters.getApiUrl + '/api/v1/client/add',
                data: {
                    type: 'factory',
                    name: payload.factoryName,
                    phone: payload.factoryPhone,
                    group: payload.factoryGroup,
                    comment: payload.factoryComment
                },
                timeout: this.getters.getApiRequestTimeLimit
            })
            .then(response => {

                if(response.data != null && response.data.status && response.data.status == '0000'){

                    //거래처 추가 성공 시
                    alert('정상적으로 추가되었습니다.')
                    return '0000'

                }

            })
            .catch((error) => {

                if(error && error.name == "InvalidJwtToken"){

                    //JWT 토큰이 정확하지 않을 시
                    alert('인증 토큰이 유효하지 않습니다.')
                    return false

                }else{

                    //저장 실패 시
                    alert('공장 등록에 실패했습니다.\n다시 시도해주세요.')

                }


            })

        }
    }
}